import React from "react";
import GetTestDetails from "./Get Skill Badges/get_all_test";
const GetSkillBadges = () => {
  return <GetTestDetails />;
};
export default GetSkillBadges;
